import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import Button from '@material-ui/core/Button';
import { menuItems } from './menuItems';
import { featureAccesses } from './featureAccesses';
import { checkFeatureAccess } from '../../../utils/helpers';
import PrivateNavLinkNew from '../../../containers/common/PrivateNavLink/PrivateNavLinkContainerNew';
import { ExternalProviderType } from '../../../enums';
import { downloadS1Link } from '../../../actions/areas/dailyPlanning/downloadS1Link';

const styles = {
  selected: 'selected',
};

class NavBarNew extends React.Component {
  state = {
    active: null,
  };

  shouldComponentUpdate(nextProps) {
    return (
      this.props.currentPathname !== nextProps.currentPathname ||
      this.props.externalProviderType !== nextProps.externalProviderType ||
      this.props.enableSendingRequestLogsToRio !== nextProps.enableSendingRequestLogsToRio
    );
  }

  onCollapseChange = () => {
    this.props.onCollapseChange();

    const funcExist = window.recalculate && typeof window.recalculate === 'function';
    if (funcExist) setTimeout(window.recalculate, 50);
  };

  isActive(match, activeChild, childId) {
    if (typeof activeChild !== 'undefined') return () => childId === activeChild.children[0].id;
    return () => this.props.currentPathname.indexOf(match) === 0;
  }

  isActiveChild(match) {
    return () => this.props.currentPathname === match;
  }

  render() {
    const activeLink = menuItems.find(item => this.isActive(item.url)());
    const activeChild = menuItems.find(item => this.isActiveChild(item.url)());

    if (this.props.appSettings.EnableMileageCap === 'false') {
      menuItems.forEach(item => {
        if (item.id === 'admin-header-navlink') {
          const milegCapExcludedList = item.children.filter(c => c.id !== 'mileageCap-header-navlink');
          item.children = milegCapExcludedList;
        }
      });
    }
    let menuItemsResult = menuItems;
    if (
      this.props.externalProviderType !== ExternalProviderType.Rio ||
      this.props.enableSendingRequestLogsToRio === 'false'
    ) {
      menuItemsResult = menuItems.filter(item => item.id !== 'requestlogs-header-navlink');
    }

    if (this.props.externalProviderType === ExternalProviderType.Emis) {
      menuItems.forEach(item => {
        if (item.id === 'admin-header-navlink') {
          item.children = item.children.filter(c => c.id !== 'external-provider-navlink');
        }
      });
    }

    return (
      <React.Fragment>
        <div className="top-level-nav">
          <div className="left-menu-actions">
            <IconButton className="collapse-btn" size="small" aria-label="Expand Less" onClick={this.onCollapseChange}>
              <ExpandLessIcon />
            </IconButton>
          </div>
          <nav>
            {menuItemsResult.map(item => (
              <PrivateNavLinkNew
                key={item.id}
                featureAccess={item.featureAccess}
                id={item.name}
                to={item.url}
                label={item.text}
                activeClassName={styles.selected}
                isActive={this.isActive(item.url)}
              >
                {item.text}
              </PrivateNavLinkNew>
            ))}
          </nav>
          <div className="right-menu-actions">
            {checkFeatureAccess(this.props.featureAccessList, featureAccesses.isInIntegrationMode) &&
              checkFeatureAccess(this.props.featureAccessList, featureAccesses.admin) &&
              this.props.externalProviderType === ExternalProviderType.SystmOne && (
                <Button
                  size="small"
                  variant="inherit"
                  color="white"
                  onClick={() => downloadS1Link(this.props.tenatCode)}
                  endIcon={<GetAppIcon />}
                >
                  Get S1 Link
                </Button>
              )}
          </div>
        </div>
        {/* submenu */}
        {activeLink && activeLink.children && activeLink.children.length > 0 ? (
          <Box className="second-level-nav" display="flex" flexGrow={1} justifyContent="center" px={2}>
            <nav>
              {activeLink.children.map(child => (
                <PrivateNavLinkNew
                  key={child.id}
                  featureAccess={child.featureAccess}
                  id={child.name}
                  to={child.url}
                  label={child.text}
                  activeClassName={styles.selected}
                  isActive={this.isActive(child.url, activeChild, child.id)}
                >
                  {child.text}
                </PrivateNavLinkNew>
              ))}
            </nav>
          </Box>
        ) : null}
      </React.Fragment>
    );
  }
}

NavBarNew.propTypes = {
  currentPathname: PropTypes.string.isRequired,
  onCollapseChange: PropTypes.func.isRequired,
};

export default NavBarNew;
